import React, { useRef, useEffect } from 'react';
import { Formik } from 'formik';
import { Box, Grid } from "@mui/material";
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'hooks';
import { useCreateClaim } from 'hooks/api/cascade';
import { SAVE, CascadeReportAction } from 'constants/actions';
import { ActivityIndicator, AppBar, Page } from 'components';
import { ClaimForm } from './components';
import { initialValues, validationSchema, actions } from './ClaimScreen.mock';

const ClaimScreen = () => {
  const formRef = useRef();
  const history = useHistory();
  const { t } = useTranslation();
  const { entityId } = useParams();
  const { isLoading, isError, mutate } = useCreateClaim(entityId);

  useEffect(() => {
    if (isError && formRef.current) {
      formRef.current.setSubmitting(false);
    }
  }, [isError]);

  const handleBackClick = () => {
    history.replace(`/cascades/${entityId}`);
  };

  const handleClaimCreate = (formData) => {
    const { action, email, ...other } = formData;
    const newFormData =
      action === CascadeReportAction.SEND_EMAIL
        ? {
            email,
            ...other,
          }
        : other;

    mutate(newFormData);
  };

  const handleSaveClick = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const handleActionItemSelected = (action) => {
    switch (action) {
      case SAVE:
        handleSaveClick();
        break;
      default:
        break;
    }
  };

  return (
    <Page>
      <Grid container direction="column">
        <AppBar
          title={t('newClaim')}
          onNavClick={handleBackClick}
          navIcon="back"
          actions={actions}
          onActionSelected={handleActionItemSelected}
        />

        <Grid item>
          <Box p={2}>
            <Formik
              initialValues={initialValues}
              innerRef={formRef}
              validationSchema={validationSchema}
              onSubmit={handleClaimCreate}
              enableReinitialize
            >
              <ClaimForm entityId={entityId} />
            </Formik>
          </Box>
        </Grid>

        {isLoading && <ActivityIndicator />}
      </Grid>
    </Page>
  );
};

export default ClaimScreen;
